
<template>
  <v-dialog max-width="600px" v-model="showDialog">
    <v-btn
      flat fab slot="activator" style="margin-top:-20px"
      class="indigo accent-1" light small mt-4 absolute middle right
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-card>
      <v-card-title>
        <h2>Define a new person</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
            <v-layout row >
              <v-flex xs2 pt-3 mx-2>
                <label class='prompt'>Primary Name</label>
              </v-flex>
              <v-flex xs3 mx-2>
                  <v-text-field  v-if="showDialog" autofocus v-model="newPerson.firstNames" name='firstNames' label="First names" />
              </v-flex>
              <v-flex xs3 >
                  <v-text-field v-model="newPerson.surname" name='surname' label="Surname" 
                    :rules="[rules.required, rules.min]" />
              </v-flex>
          </v-layout> 
          <v-layout row >
              <v-flex xs2 pt-3 mx-2>
                <label class='prompt'>Service</label>
              </v-flex>
              <v-flex xs3 mx-2>
                 <v-select  v-model="newPerson.service" :items="serviceValues" single-line
                  :rules="[rules.required, rules.min]" ></v-select>
              </v-flex>
          </v-layout> 

          <provenance-and-note v-bind:record="newPerson"/>
 
          <v-layout row>
            <v-flex xs12>
              <div class="error" v-html="error"></div>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <v-btn dark class="indigo darken-1" :loading="loading" @click="createPerson">
                <v-icon left>save_alt</v-icon>Define New Person
              </v-btn>
            </v-flex>
          </v-layout>
         </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>        

<script>
import Panel from "@/components/Panel";
import PeopleService from "@/services/PeopleService";

export default {
  components: { Panel },
  data () {
    return {
      serviceValues: ['Army', 'Merchant Navy', 'RAAF', 'RAN'],
      newPerson: {
        firstNames: "",
        surname: "",
        service: "",
        provenance: "",        
        note: ""
      },
      error: null,
      message: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 3 || 'Minimum of 3 characters is required.'
      },
      loading: false,
      showDialog: false
    };
  },

  methods: {
    async createPerson () {
      console.log("IN createPerson");
      if (!this.$refs.form.validate()) return ;

      this.error = null ;
      try {
        this.loading = true ;
        const response = await PeopleService.create(this.newPerson);
        console.log("createPerson response: " + response);
        this.showDialog = false ;
        this.$renderToastInParent(this, "Person " + this.newPerson.firstNames + " " + this.newPerson.surname + " successfully created") ;
        this.$router.push('/person/' + response.data.id) ;
      }
      catch (err) {
        console.log("catch err:" + err);
        this.error = err.response.data.error ;
      }
      finally {
        this.loading = false ;
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PersonCreate.vue